<template>
  <NavigationMenuItem class="font-medium" as-child>
    <NavigationMenuLink :class="`content--${item.type === 'Button' ? 'button' : 'outline-button'}`" :active="isActive"
      v-if="item.type === 'Button' || item.type === 'Outline button'" as-child>
      <a :href="url" :target="item.link?.target || '_self'">{{ item.text }}</a>
    </NavigationMenuLink>
    <NavigationMenuLink v-else-if="item.type === 'Link'" :active="isActive" as-child>
      <a :href="url" :target="item.link?.target || '_self'">{{ item.text }}</a>
    </NavigationMenuLink>
    <NavigationMenuLink v-else-if="item.type === 'Only image'" :active="isActive" as-child>
      <a :href="url" :target="item.link?.target || '_self'"><img :src="item.image?.text" /></a>
    </NavigationMenuLink>
    <div class="relative dropdown" v-else-if="item.type === 'Dropdown'">
      <NavigationMenuTrigger class="dropdown-trigger">{{ item.text }}</NavigationMenuTrigger>
      <NavigationMenuContent class="z-2 dropdown-content">
        <NavigationMenuLink v-for="(navItem, index) in item.subNavigationElements" :key="index" :href="navItem.url"
          :target="navItem.target ? navItem.target : '_self'">
          {{ navItem.text }}
        </NavigationMenuLink>
      </NavigationMenuContent>
    </div>
    <NavigationMenuLink v-else>{{ item.text }}</NavigationMenuLink>
  </NavigationMenuItem>
</template>

<script setup lang="ts">
import { computed } from "vue"
import type { INavigationElement } from "./NavigationBar.model";
import {
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuTrigger,
  NavigationMenuContent
} from '@/components/ui/navigation-menu'

const props = defineProps<{ item: INavigationElement }>()
const url = computed(() => {
  if (props.item.link) {
    return props.item.link.url
  }
  return "#"
})


const isActive = computed(() => {
  return url.value === window.location.pathname
})
</script>

<style lang="scss">
@reference "../../main.scss";

.content--outline-button {
  @apply border border-solid border-primary text-primary hover:bg-primary hover:text-white transition-colors duration-400;
}

.content--button {
  @apply bg-primary text-primary hover:bg-primary-dark text-white transition-colors duration-400;
}

.top-navigation {

  .content--outline-button,
  .content--button {
    height: 25px;
    font-size: 0.65rem;
    display: flex;
    justify-content: center;
  }

}
</style>
